var _path, _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgListViewBlue(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 50,
    height: 50,
    viewBox: "0 0 50 50",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_27_8007)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask0_27_8007",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 50,
    height: 50
  }, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M50 0H0V50H50V0Z",
    fill: "white"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_27_8007)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M3.97939 2.14844C2.32031 2.14844 0.976562 3.45293 0.976562 5.06182V7.97197C0.976562 9.58096 2.32031 10.8855 3.97939 10.8855H46.0204C47.6796 10.8855 49.0234 9.58096 49.0234 7.97197V5.06182C49.0234 3.45293 47.6796 2.14844 46.0204 2.14844H3.97939ZM3.97939 15.2521C2.32031 15.2521 0.976562 16.5552 0.976562 18.1641V21.0759C0.976562 22.6863 2.32031 23.9878 3.97939 23.9878H46.0204C47.6796 23.9878 49.0234 22.6863 49.0234 21.0759V18.1641C49.0234 16.5552 47.6796 15.2521 46.0204 15.2521H3.97939ZM3.97939 28.3544C2.32031 28.3544 0.976562 29.6589 0.976562 31.2679V34.178C0.976562 35.7869 2.32031 37.0913 3.97939 37.0913H46.0204C47.6796 37.0913 49.0234 35.7869 49.0234 34.178V31.2679C49.0234 29.6589 47.6796 28.3544 46.0204 28.3544H3.97939Z",
    fill: "#314D7E"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M3.97939 41.459C2.32031 41.459 0.976562 42.7634 0.976562 44.3723V47.2824C0.976562 48.8913 2.32031 50.1958 3.97939 50.1958H46.0204C47.6796 50.1958 49.0234 48.8913 49.0234 47.2824V44.3723C49.0234 42.7634 47.6796 41.459 46.0204 41.459H3.97939Z",
    fill: "#314D7E"
  })))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_27_8007"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 50,
    height: 50,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgListViewBlue);
export default __webpack_public_path__ + "static/media/list_view_blue.cb8e15661104b9d4a1ca08aa58ec2f07.svg";
export { ForwardRef as ReactComponent };